import Header from "./components/common/Header";
import About from "./components/about/About";
import Skills from "./components/skills/Skills";
import Projects from "./components/projects/Projects";
import Experience from "./components/experience/Experience";
import Contact from "./components/contact/Contact";
// import Footer from "./components/Footer";
import Achievements from "./components/achievements/Achievements";
import DownloadCV from "./components/downloadCV/DownloadCV";

function App() {
  return (
    <>
      <Header />
      <About />
      <Achievements />
      <Experience />
      <Skills />
      <Projects />
      <Contact />
      {/* <DownloadCV /> */}
      {/* <Footer /> */}
    </>
  );
}

export default App;
